export default "__VITE_ASSET__fcfa8025__"